/**
 * This mixin solves the problem with z-indexes for elements.
 *
 * The given element is attached to the <body>
 * and receives a high z-index.
 * 
 * This ensures that given element cannot be overlaid
 * by any element in the layout.
 */

export function useTeleportToBody(controller) {
  controller._teleportState = {
    element: null,
    originalParent: null,
    originalNextSibling: null,
    originalZIndex: null,
  };

  controller.teleportElementToBody = function(element) {
    if (!element) return;

    const state = controller._teleportState;
    state.element = element;

    if (state.originalZIndex == null) {
      const inline = element.style.zIndex;
      if (inline && inline !== '') {
        state.originalZIndex = inline;
      } else {
        const computed = window.getComputedStyle(element).zIndex;
        state.originalZIndex = computed === 'auto' ? '' : computed;
      }
    }

    element.style.zIndex = '999999';

    try {
      if (element.parentNode !== document.body) {
        state.originalParent = element.parentNode;
        state.originalNextSibling = element.nextSibling;
        document.body.appendChild(element);
      }
    } catch (e) {
      /* ignore DOM errors during teleport */
    }
  };

  controller.restoreTeleportedElement = function() {
    const state = controller._teleportState;
    const element = state.element;
    if (!element) return null;

    if (state.originalParent) {
      try {
        if (state.originalNextSibling && state.originalNextSibling.parentNode === state.originalParent) {
          state.originalParent.insertBefore(element, state.originalNextSibling);
        } else {
          state.originalParent.appendChild(element);
        }
      } catch (e) {
        /* ignore DOM errors during restore */
      } finally {
        state.originalParent = null;
        state.originalNextSibling = null;
      }
    }

    if (state.originalZIndex != null) {
      element.style.zIndex = state.originalZIndex;
    } else {
      element.style.zIndex = '';
    }
    state.originalZIndex = null;

    state.element = null;
    return element;
  };

  controller.getTeleportedElement = function() {
    return controller._teleportState.element;
  };
}